<template src="./Index.html"></template>

<script>
export default {
  components: {},
  created() {
    if (this.$route.query.params != null) {
      this.filters.jobType = this.$route.query.params;

    }
    this.getAll();
    this.$store.dispatch("lookups/getLookups");
    this.$store.dispatch("lookups/getSpecialties");
    this.$store.dispatch("lookups/getUniversities");


  },
  computed: {

    specialties() {
      return [
        { value: 0, label: "الكل" }, ...this.$store.state.lookups.specialties];
    },
    sourceTypes() {
      return [
        { value: 0, label: "الكل" }, ...this.$store.getters["lookups/getLookupByType"](
        this.$lookupTypes.SourceTypes
      )];
    },
   
    sources() {
      return [
        { value: 0, label: "الكل" }, ...this.$store.getters["lookups/getUniversityByType"](
        this.filters.sourceTypeId
      )];
    },
    
    
    pageCount() {
      return Math.ceil(
        this.totalItems /
        this.filters.pageSize
      );
    },
  },
  data() {
    return {
     subtitle: "",
      items: [
        {
          text: "التقارير",
        },
        {
          text: "تقرير مؤهلات الموظفين  ",
        },
      ],
      itemId: 0,
      view: 0,
      data: [],
      totalItems: 0,
      filters: {
        page: 1,
        pageSize: 10,
        specialtyId: 0,
        sourceTypeId: 0,
        sourceId: 0,
      },
      headers: [
        {
          text: "الرقم التسلسلي ",
          value: "employeeNo",
          sortable: false,
          align: "start",
        },
        {
          text: "اسم الموظف",
          value: "fullName",
          sortable: false,
          align: "start",
        },
        {
          text: "الادارة",
          value: "administrationName",
          sortable: false,
          align: "start",
        },
        {
          text: "القسم",
          value: "departmentName",
          sortable: false,
          align: "start",
        },
          {
          text: "الوحدة",
          value: "unitName",
          sortable: false,
          align: "start",
        },
        {
          text: "عدد المؤهلات ",
          value: "qualificationCount",
          sortable: false,
          align: "start",
        },
       ],
    };
  },
  methods: {
    getAll(page) {
      this.filters.page = page || 1;
      this.$store.dispatch("reports/getEmployeesQualifications", this.filters).then((res) => {
        this.data = res.data;
        this.totalItems = res.totalItems;
      });
    },
    download() {
      let filters = {
        specialtyId: this.filters.specialtyId,
        sourceTypeId: this.filters.sourceTypeId,
        sourceId: this.filters.sourceId,
      };
  
      const paramsString = Object.entries(filters)
        .filter(([, val]) => val !== null)
        .map(([key, val]) => `${key}=${val}`)
        .join("&");
      window.open(`/api/reports/EmployeesQualificationsExcel?${paramsString}`, "_blank");
    },

  },
};
</script>
